import { useSelector } from 'react-redux';
import BaseTable from '../../components/BaseTable';
import { fetchDoctorProfilesList } from '../../api/careRecords';
import { CARE_TABLE_KIND, useTableColumns } from '../../hooks/columns';
import { useCareList } from '../../hooks/useCareList';

export default function Doctors() {
  const token = useSelector((state) => state.auth.token);
  const columns = useTableColumns(CARE_TABLE_KIND.doctors);
  const { data, loading, error } = useCareList(fetchDoctorProfilesList, token);

  return (
    <div className="care-page">
      <BaseTable
        columns={columns}
        dataSource={data}
        loading={loading}
        error={error}
        searchKeys={[
          'id',
          'specialty',
          'clinic_or_hospital',
          'language',
          'user.email',
          'user.username',
          'user.name',
          'user.id',
          'user_email',
          'user_name',
          'user_id'
        ]}
        searchPlaceholder="Search id, specialty, clinic, user…"
        emptyText="No doctor profiles found."
      />
    </div>
  );
}
